<mat-form-field >
  <mat-label>{{config.name}}</mat-label>
  <input matInput type="text" id="{{config.configId}}" name="{{config.configId}}"  [(ngModel)]="config.value" (ngModelChange)="markDirty()"/>
</mat-form-field>